<template>
  <!-- ケアオーケストレータークライアント証明書 -->
  <div id="ClientCertificate">
      <div class="labelTitle lable">ケア オーケストレーター　クライアント証明書</div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <template>
              <div style="margin-left:10px; display:flex;justify-content: end;">
                <div style="width: 150px;text-align: left"></div>
                <div style="margin-right:20px;">
                  <b-button class="is-primary" style="width:350px" v-on:click="cancelCertificate()">クライアント認証を「有効にしない」にする</b-button>
                </div>
              </div>
            <div>
              <div style="margin-top:0px;margin-left:10px; display:flex">
                <div style="width: 150px;text-align: left">証明書発行日</div>
                <div style="margin-left:20px">
                  <input v-model="issuedDate" @change="setExpiredDates" type="date" name="証明書発行日" class="validate" validate="required|date">
                </div>
              </div>
              <div style="margin-top:20px;margin-left:10px; display:flex">
                <div style="width: 150px;text-align: left">ダウンロード期限日</div>
                <div style="margin-left:20px">
                  <input v-model="downloadExpirationDate" type="date" name="ダウンロード期限日" class="validate" validate="required|date">
                </div>
              </div>
              <div style="margin-top:20px;margin-left:10px; display:flex">
                <div style="width: 150px;text-align: left">証明書有効期限日</div>
                <div style="margin-left:20px">
                  <input v-model="expirationDate" type="date" name="証明書有効期限日" class="validate" validate="required|date">
                </div>
              </div>
              <div style="margin-top:20px;margin-left:10px; display:flex">
                <div style="width: 150px;text-align: left">クライアント証明書</div>
                <div style="margin-left:20px" class="upload_area" @dragenter="dragEnter">
                   <span class="upload_span">ここにファイルをドラッグアンドドロップするか、「ファイルを追加」を押します。</span>
                </div>
                <b-modal :active.sync="isUpdateModal" has-modal-card>
                  <div class="modal-card uploadModal"
                    @dragleave="dragLeave"
                    @drop.prevent="fileDrop"
                  >
                    ここにファイルをドロップします。
                  </div>
                </b-modal>
                <div style="margin-top:0px;margin-left:20px">
                  <b-upload
                    v-model="addfile"
                    class="file-label"
                    v-on:input="addUploadFile"
                    >
                    <span class="file-cta">
                      <span class="file-label">ファイルを追加</span>
                    </span>
                  </b-upload>
                </div>
              </div>
              <div style="margin-top:20px;margin-left:10px; display:flex">
                <div style="width: 150px;text-align: left"></div>
                <div style="margin-left:20px">
                  <ul v-if="fileName">
                      <li class="reportFiles">
                        <b-icon icon="paperclip"/>{{fileName}} <a @click="removeUploadFile()"><b-icon icon="delete-forever-outline"/></a>
                      </li>
                  </ul>
                </div>
              </div>
              <div style="margin-top:20px;margin-left:10px; display:flex">
                <div style="width: 150px;text-align: left;margin-top:10px;">パスワード</div>
                <div style="margin-left:20px">
                  <input v-model="password" style="width:500px;height: 40px;" type="string" name="パスワード" class="validate" validate="required" placeholder="パスワードを入力してください">
                </div>
              </div>
            </div>
           <div style="margin-top:20px; display:flex; justify-content: center;">
              <b-button class="is-primary" style="width:250px" v-on:click="uploadCertificate()">証明書のアップロード</b-button>
            </div>
          </template>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientCertificate",
  methods: {
    doSearch: function() {
      var executeApi = this.getCoClientCertificateInfoPOST;
      var successCallBack = this.getCoClientCertificateInfoPOSTSuccess;
      var errorCallBack = this.getCoClientCertificateInfoPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    getCoClientCertificateInfoPOST: function(client) {
      return client.apis.internalCoSetting.getCoClientCertificateInfoPOST({
        body:{
          careOrchestratorInstitutionId:this.careOrchestratorInstitutionId
        }
      });
    },
    getCoClientCertificateInfoPOSTSuccess: function(result) {
      // 検索結果取得
      this.issuedDate = result.obj.issuedDate ? result.obj.issuedDate : null;
      this.downloadExpirationDate = result.obj.downloadExpirationDate ? result.obj.downloadExpirationDate : null;
      this.expirationDate = result.obj.expirationDate ? result.obj.expirationDate : null;
      this.fileName = result.obj.fileName ? result.obj.fileName : "";
      this.password = result.obj.password ? result.obj.password : "";
     },
    getCoClientCertificateInfoPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      this.isUpdateModal = false;
    },
    fileDrop: async function(event) {
      if(this.fileName){
         this.showMessage("追加できるファイルは1件までです。"); 
      } else {
        if(event.dataTransfer.items.length > 1){
          this.showMessage("追加できるファイルは1件までです。"); 
        } else {
          const item = event.dataTransfer.items[0];
          const entry = item.webkitGetAsEntry();
          if(entry.isDirectory){
            this.showMessage("フォルダーは追加できません。"); 
          } else {
            this.targetFile = event.dataTransfer.files[0];
            this.fileName = event.dataTransfer.files[0].name;
          }
        }
      }
      this.isUpdateModal = false;
    },
    addUploadFile: function(){
      this.targetFile = this.addfile;
      this.fileName =  this.addfile.name;
      this.addfile = null;

    },
    removeUploadFile: function(){
      this.targetFile = null;
      this.fileName = "";
    },
    //証明書のアップロード処理
    uploadCertificate: async function(){
      // バリデーションチェック
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      if(!this.fileName){
        result.isError = true;
        result.msg =  result.msg + "クライアント証明書ファイルを指定してください。\n"
      }
      if(result.isError){
        this.showErrorMessage(result.msg)
      }else{
        let expirationDateMessage = "";
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        today = today.getTime();
        let targetDate = new Date(this.issuedDate).getTime();
        if(targetDate < today){
          if(expirationDateMessage){
            expirationDateMessage += "、"
          }
          expirationDateMessage += "証明書有効期限"
        }
        targetDate = new Date(this.downloadExpirationDate + " 00:00:00").getTime();
        if(targetDate < today){
          if(expirationDateMessage){
            expirationDateMessage += "、"
          }
          expirationDateMessage += "ダウンロード期限日"
        }
        targetDate = new Date(this.expirationDate + " 00:00:00").getTime();
        if(targetDate < today){
          if(expirationDateMessage){
            expirationDateMessage += "、"
          }
          expirationDateMessage += "証明書有効期限日"
        }
        if(expirationDateMessage){
          this.$dialog.confirm({
            title: "　",
            message: expirationDateMessage + " が本日より前の日付で指定されています。<br>証明書のアップロードを続けますか？",
            cancelText: "キャンセル",
            onConfirm: async () => {
              this.uploadCoCertificateFilePOST();
            }
          })
        } else {
          this.uploadCoCertificateFilePOST();
        }
        
      }
    },
    uploadCoCertificateFilePOST: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalCoSetting.uploadCoCertificateFilePOST({
            careOrchestratorInstitutionId: _this.careOrchestratorInstitutionId,
            issuedDate : _this.issuedDate,
            downloadExpirationDate : _this.downloadExpirationDate,
            expirationDate : _this.expirationDate,
            fileName: _this.fileName,
            password: _this.password,
            file: _this.targetFile,
          })
        },
        this.uploadCoCertificateFilePOSTSuccess,
        this.uploadCoCertificateFilePOSTError,
      ); 
    },
    uploadCoCertificateFilePOSTSuccess: function(result){
      if(this.targetFile){
        this.showErrorMessage("証明書ファイルをアップロードしました。");
      } else {
        this.showErrorMessage("証明書情報を更新しました。");
      }
    },
    uploadCoCertificateFilePOSTError: function(result){
      this.showErrorMessage(result);
    },
    //クライアント認証キャンセル
    cancelCertificate: function(){
      this.$dialog.confirm({
        title: "　",
        message: "ケア オーケストレーターのクライアント認証を「有効にしない」に変更します。<br/>内容が正しいことを確認して「OK」ボタンを押してください。",
        cancelText: "キャンセル",
        onConfirm: async () => {
          var executeApi = this.cancelCertificatePOST;
          var successCallBack = this.cancelCertificatePOSTSuccess;
          var errorCallBack = this.cancelCertificatePOSTError;
          // WebAPI Call
          await this.apiCall(executeApi, successCallBack, errorCallBack)
        }
      })
    },
    cancelCertificatePOST: function(client){
      return client.apis.internalCoSetting.cancelCertificatePOST({
        body:{
          careOrchestratorInstitutionId:this.careOrchestratorInstitutionId
        }
      });
    },
    cancelCertificatePOSTSuccess: function(result){
      this.showErrorMessage("クライアント認証を「有効にしない」に変更しました。");
      this.$router.push({ name: "COUploadCertificate" , params: { searchConditions: this.searchConditions }});
    },
    cancelCertificatePOSTError: function(result){
      this.showErrorMessage(result);
    },
    //証明書発行日変更時の処理
    setExpiredDates: function(){
      let _issuedDate = new Date(this.issuedDate);
      let newExpirationDate = new Date(this.issuedDate).setDate(_issuedDate.getDate() + (365 * 2));
      let newDownloadExpirationDate = new Date(this.issuedDate).setDate(_issuedDate.getDate() + 14);
      this.expirationDate = this.yyyy_hyp_MM_hyp_dd(new Date(newExpirationDate));
      this.downloadExpirationDate = this.yyyy_hyp_MM_hyp_dd(new Date(newDownloadExpirationDate));
    }
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let searchConditions = this.$route.params["searchConditions"];
    return {
      careOrchestratorInstitutionId:careOrchestratorInstitutionId,
      searchConditions:searchConditions,
      issuedDate:"",
      downloadExpirationDate:"",
      expirationDate:"",
      password:"",
      fileName:"",
      isUpdateModal: false,
      targetFile:null,
      addfile:null
    };
  },
  async mounted() {
    await this.doSearch();
  },
  filters: {},
  components: {
  },
};
</script>
<style lang="scss" scoped>
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/setting/ClientCertificate.vue